import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 -960 960 960"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M480-80q-73-9-145-39.5T206.5-207 115-351 80-560v-40h40q51 0 105 13t101 39q12-86 54.5-176.5T480-880q57 65 99.5 155.5T634-548q47-26 101-39t105-13h40v40q0 122-35 209t-91.5 144-128 87.5T480-80m-2-82q-11-166-98.5-251T162-518q11 171 101.5 255T478-162m2-254q15-22 36.5-45.5T558-502q-2-57-22.5-119T480-742q-35 59-55.5 121T402-502q20 17 42 40.5t36 45.5m78 236q37-12 77-35t74.5-62.5 59-98.5T798-518q-94 14-165 62.5T524-332q12 32 20.5 70t13.5 82M480-80"
    }, null, -1)
  ]))]))
}
export default { render: render }